import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const SettingsFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 122%;
  background: #fff;
  border-radius: ${pxToRem(19.2)};
  box-shadow: 0px ${pxToRem(4.8)} ${pxToRem(14.4)} rgba(0, 0, 0, 0.1);
  min-width: ${pxToRem(360)};
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${pxToRem(24)} ${pxToRem(36)};

  h2 {
    color: rgb(31, 10, 53);
    font-size: ${pxToRem(33.6)};
    font-weight: 700;
    margin: 0;
  }
`;

export const ModalBody = styled.div`
  color: rgb(185, 185, 185);
  font-size: ${pxToRem(21.6)};
  font-weight: 500;
  margin: ${pxToRem(36)} ${pxToRem(36)};
  margin-bottom: ${pxToRem(16)};
`;

export const Divider = styled.div`
  width: 100%;
  height: ${pxToRem(1.2)};
  background-color: rgb(225, 224, 229);
`;

export const FieldWrapper = styled.div`
  margin-bottom: ${pxToRem(19.2)};
`;

export const Input = styled.input`
  width: 100%;
  padding: ${pxToRem(14.4)} ${pxToRem(19.2)};
  font-size: ${pxToRem(16.8)};
  border: ${pxToRem(1.2)} solid rgba(31, 10, 53, 0.1);
  border-radius: ${pxToRem(9.6)};
  background: #f7f8f8;
  
  &:focus {
    border-color: #724edc;
    background: rgba(114, 82, 220, 0.15);
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: end;
  flex-direction: column;
  gap: ${pxToRem(9.6)};
  margin: auto 0 ${pxToRem(36)} 0;
`;

export const SubmitButton = styled.button<{ isDisabled?: boolean }>`
  padding: ${pxToRem(16.8)} ${pxToRem(33.6)};
  width: ${pxToRem(442.8)};
  border: none;
  border-radius: ${pxToRem(14.4)};
  background: ${({ isDisabled }) =>
    isDisabled ? "rgb(114, 82, 220)" : "rgb(114, 82, 220)"};
  color: rgb(255, 255, 255);
  font-size: ${pxToRem(21.6)};
  font-weight: 600;
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  margin: 0 ${pxToRem(36)};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.3 : 1)};
  
  &:hover {
    background: ${({ isDisabled }) =>
      isDisabled ? "rgb(114, 82, 220)" : "#603cbc"};
  }
`;

export const DeleteButton = styled(SubmitButton)`
  background: ${({ isDisabled }) =>
    isDisabled ? "rgb(242, 40, 98)" : "rgb(242, 40, 98)"};
  
  &:hover {
    background: ${({ isDisabled }) =>
      isDisabled ? "rgb(242, 40, 98)" : "#e52c6d"};
  }
`;

export const ErrorMessage = styled.div`
  font-size: ${pxToRem(14.4)};
  color: #ff4d4d;
  margin-bottom: ${pxToRem(9.6)};
`;

export const Manual = styled.a`
  align-self: start;
  color: rgb(114, 82, 220);
  font-size: ${pxToRem(21.6)};
  font-weight: 700;
  line-height: ${pxToRem(26.4)};
  cursor: pointer;
  margin: 0 ${pxToRem(36)} ${pxToRem(22)} ${pxToRem(36)};
  text-decoration: none;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-1px);
  }
`;
